module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('ul', {
    staticClass: "headMenu"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "menuItem",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('router-link', {
    staticClass: "menuItem",
    attrs: {
      "to": "/product"
    }
  }, [_vm._v("产品")]), _vm._v(" "), _c('router-link', {
    staticClass: "menuItem",
    attrs: {
      "to": "/example"
    }
  }, [_vm._v("案例")]), _vm._v(" "), _c('router-link', {
    staticClass: "menuItem",
    attrs: {
      "to": "/methods"
    }
  }, [_vm._v("商务合作")]), _vm._v(" "), _c('router-link', {
    staticClass: "menuItem",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('router-link', {
    staticClass: "menuItem",
    attrs: {
      "to": "/join"
    }
  }, [_vm._v("加入我们")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "businessLogo"
  }, [_c('img', {
    staticClass: "businessLogo",
    attrs: {
      "src": require("../assets/haokuLogo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "qqLogo2"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://wpa.qq.com/msgrd?v=3&uin=120605580&site=qq&menu=yes"
    }
  }, [_c('img', {
    staticClass: "qqLogo",
    attrs: {
      "src": require("../assets/qq.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "qqLogo2"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://wpa.qq.com/msgrd?v=3&uin=451429350&site=qq&menu=yes"
    }
  }, [_c('img', {
    staticClass: "qqLogo",
    attrs: {
      "src": require("../assets/qq.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37a7b166","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 276
// module chunks = 1